const FixableSection = () => (
  <section className="fixable-section">
    <div className="fixable-card">
      <h2 className="fixable-title">
        <span className="block text-white">THIS IS</span>
        <span className="block text-primary">FIXABLE.</span>
      </h2>
      <p className="mt-6 mb-0 text-lg leading-relaxed max-w-2xl text-void-muted">
        You don't need a rebrand. You need a restructuring. You must align your digital presence with your actual business reality.
      </p>

      <div className="fix-server-list">
        <div className="fix-server-item">
          <span className="fix-index">[01]</span>
          <span className="fix-text">The embarrassment goes away immediately.</span>
          <span className="fix-status">[VERIFIED]</span>
        </div>
        <div className="fix-server-item">
          <span className="fix-index">[02]</span>
          <span className="fix-text">Your digital presence finally projects the actual gravity and authority of your business.</span>
          <span className="fix-status">[VERIFIED]</span>
        </div>
        <div className="fix-server-item">
          <span className="fix-index">[03]</span>
          <span className="fix-text">The system filters the noise, giving you back hours of operational time.</span>
          <span className="fix-status">[VERIFIED]</span>
        </div>
      </div>

      <button
        className="section-guide cursor-pointer border-0 bg-transparent"
        onClick={() => document.getElementById('methodology')?.scrollIntoView({ behavior: 'smooth' })}
        aria-label="Scroll to methodology"
      >
        <p className="section-guide-label">THIS IS HOW</p>
        <div className="section-guide-arrow">↓</div>
      </button>
    </div>
  </section>
);

export default FixableSection;
